import React from "react";
import {
  RenderLikertScaleAnswer,
  RenderLikertNaScaleAnswer,
  RenderStringAnswer,
} from "../share_feedback/addNewButtonElements";
import { VriddhiResponseOptions } from "../share_feedback/Vriddhi/VriddhiResponseOptions";
import { AttributeQuestionEmoji, ResponseScaleProp, ShareFeedbackAttribute } from "../../../type";

interface QuestionAnswerRendererProps {
  scaleName: string;
  question: any;
  idx: number;
  idx_1: number;
  emojiSelected: Array<AttributeQuestionEmoji>;
  setEmojiSelected: React.Dispatch<React.SetStateAction<Array<AttributeQuestionEmoji>>>;
  shareFeedbackData: Array<ShareFeedbackAttribute>;
  setShareFeedbackData: React.Dispatch<React.SetStateAction<Array<ShareFeedbackAttribute>>>;
  onAnyChange: (value: boolean) => void;
  responseScales: Array<ResponseScaleProp>;
}

export const QuestionAnswerRenderer: React.FC<QuestionAnswerRendererProps> = ({
  scaleName,
  question,
  idx,
  idx_1,
  emojiSelected,
  setEmojiSelected,
  shareFeedbackData,
  setShareFeedbackData,
  onAnyChange,
  responseScales,
}) => {
  switch (scaleName) {
    case "LIKERT":
      return emojiSelected[idx] ? (
        <RenderLikertScaleAnswer
          idx={idx} idx_1={idx_1}
          emojiSelected={emojiSelected} setEmojiSelected={setEmojiSelected}
          shareFeedbackData={shareFeedbackData} setShareFeedbackData={setShareFeedbackData}
          scaleVersion={question.scaleVersion}
        />
      ) : null;
    case "LIKERT_NA":
      return emojiSelected[idx] ? (
        <RenderLikertNaScaleAnswer
          idx={idx} idx_1={idx_1}
          emojiSelected={emojiSelected} setEmojiSelected={setEmojiSelected}
          shareFeedbackData={shareFeedbackData} setShareFeedbackData={setShareFeedbackData}
          scaleVersion={question.scaleVersion}
        />
      ) : null;
    case "STRING":
      return (
        <RenderStringAnswer
          question={question} idx={idx} idx_1={idx_1}
          shareFeedbackData={shareFeedbackData} setShareFeedbackData={setShareFeedbackData}
          onAnyChange={onAnyChange}
        />
      );
    case "VRIDDHI":
      return emojiSelected[idx] ? (
        <VriddhiResponseOptions
          idx={idx} idx_1={idx_1}
          emojiSelected={emojiSelected} setEmojiSelected={setEmojiSelected}
          shareFeedbackData={shareFeedbackData} setShareFeedbackData={setShareFeedbackData}
          scaleVersion={question.scaleVersion}
          responseScales={responseScales} responseScales2={[]}
        />
      ) : null;
    default:
      return null;
  }
};
